'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// colours
var colorShark = '#2a2c2e';
var colorAthensGrey = '#f7f7f8';
var colorShuttleGrey = '#54595f';
var colorGainsboro = '#d8d8d8';
var colorDarkRaja = '#8C5415';
var colorRaja = '#FACA69';
var colorLightRaja = '#FFF9EE'; // brand

var colorTelusGreen = '#6c0';
var colorTelusPurple = '#4b286d';
var colorAccessibleGreen = '#2B8000';
var colorWhite = '#fff'; // grey

var colorGreyShark = '#2a2c2e';
var colorGreyShuttle = '#54595f';
var colorGreyRaven = '#71757b';
var colorGreyGainsboro = '#d8d8d8';
var colorGreyAthens = '#f7f7f8'; // notification

var colorLavenderBlush = '#fff6f8';
var colorPanache = '#f4f9f2';
var colorWhiteLilac = '#f2eff4';
var colorCardinal = '#c12335';
var colorRajahDark = '#8C5415';
var colorRajah = '#FACA69';
var colorRajahLight = '#FFF9EE'; // typography

var colorLink = colorGreyShuttle;
var colorText = colorGreyShark; // tokens

var colorPrimary = colorAccessibleGreen;
var colorSecondary = colorTelusPurple; // icons

var colorIconPrimary = colorPrimary;
var colorIconSecondary = colorSecondary;
var colorIconDisabled = colorGreyShuttle;
var colorIconError = colorCardinal;

exports.colorAccessibleGreen = colorAccessibleGreen;
exports.colorAthensGrey = colorAthensGrey;
exports.colorCardinal = colorCardinal;
exports.colorDarkRaja = colorDarkRaja;
exports.colorGainsboro = colorGainsboro;
exports.colorGreyAthens = colorGreyAthens;
exports.colorGreyGainsboro = colorGreyGainsboro;
exports.colorGreyRaven = colorGreyRaven;
exports.colorGreyShark = colorGreyShark;
exports.colorGreyShuttle = colorGreyShuttle;
exports.colorIconDisabled = colorIconDisabled;
exports.colorIconError = colorIconError;
exports.colorIconPrimary = colorIconPrimary;
exports.colorIconSecondary = colorIconSecondary;
exports.colorLavenderBlush = colorLavenderBlush;
exports.colorLightRaja = colorLightRaja;
exports.colorLink = colorLink;
exports.colorPanache = colorPanache;
exports.colorPrimary = colorPrimary;
exports.colorRaja = colorRaja;
exports.colorRajah = colorRajah;
exports.colorRajahDark = colorRajahDark;
exports.colorRajahLight = colorRajahLight;
exports.colorSecondary = colorSecondary;
exports.colorShark = colorShark;
exports.colorShuttleGrey = colorShuttleGrey;
exports.colorTelusGreen = colorTelusGreen;
exports.colorTelusPurple = colorTelusPurple;
exports.colorText = colorText;
exports.colorWhite = colorWhite;
exports.colorWhiteLilac = colorWhiteLilac;
